export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10819.e5968085.jpg";